import React from 'react';
import type { TooltipRenderProps } from 'react-joyride';
import { cn } from '@/lib/cn';

export const TourTooltip: React.FC<TooltipRenderProps> = ({
  index,
  step,
  size,
  backProps,
  primaryProps,
  skipProps,
  isLastStep,
  tooltipProps,
}) => {
  const isInteractive = !!(step.data as any)?.interactive;

  return (
    <div
      {...tooltipProps}
      className={cn(
        'rounded-2xl shadow-2xl',
        'border border-gray-200 dark:border-gray-700',
        'max-w-sm w-full p-6'
      )}
      style={{ backgroundColor: 'var(--color-card, #ffffff)' }}
    >
      {/* Progress dots */}
      <div className="flex gap-1 mb-4">
        {Array.from({ length: size }, (_, i) => (
          <div
            key={i}
            className={cn(
              'h-1 flex-1 rounded-full transition-colors',
              i <= index
                ? 'bg-gradient-to-r from-[#AD1122] to-[#BC952E]'
                : 'bg-gray-200 dark:bg-gray-700'
            )}
          />
        ))}
      </div>

      {/* Title */}
      {step.title && (
        <h3
          className="text-lg font-bold mb-2"
          style={{ color: 'var(--color-text, #111)' }}
        >
          {step.title as string}
        </h3>
      )}

      {/* Content */}
      <div
        className="text-sm mb-4 leading-relaxed"
        style={{ color: 'var(--color-text-secondary, #666)' }}
      >
        {step.content}
      </div>

      {/* Interactive hint */}
      {isInteractive && (
        <div className="flex items-center gap-2 mb-4 px-3 py-2 rounded-lg bg-[#AD1122]/10 border border-[#AD1122]/20">
          <svg className="w-5 h-5 text-[#AD1122] flex-shrink-0 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
          </svg>
          <span className="text-sm font-medium text-[#AD1122]">
            Clicca sull'elemento evidenziato
          </span>
        </div>
      )}

      {/* Actions */}
      <div className="flex items-center justify-between">
        <button
          {...skipProps}
          className="text-sm text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
        >
          Salta tutorial
        </button>
        <div className="flex gap-2">
          {!isInteractive && index > 0 && (
            <button
              {...backProps}
              className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
            >
              Indietro
            </button>
          )}
          {!isInteractive && (
            <button
              {...primaryProps}
              className="px-5 py-2 text-sm font-medium text-white rounded-lg bg-[#AD1122] hover:bg-[#8A0D1B] shadow-md hover:shadow-lg transition-all"
            >
              {isLastStep ? 'Inizia!' : 'Avanti'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
